import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
import CollaborationSidebarPropsContext from '../contexts/CollaborationSidebarPropsContext';
import useGetPropsFromFAS from '../features/fas/hooks/useGetPropsFromFAS';
export default function useCollaborationSidebarProps() {
  "use memo";

  const $ = _c(11);
  const props = useContext(CollaborationSidebarPropsContext);
  const t0 = (props === null || props === void 0 ? void 0 : props.appName) || "";
  const t1 = props === null || props === void 0 ? void 0 : props.enabledFeatures;
  const t2 = props === null || props === void 0 ? void 0 : props.skipFas;
  let t3;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      appName: t0,
      enabledFeatures: t1,
      skipFas: t2
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    fasProps,
    loading: isLoadingFAS
  } = useGetPropsFromFAS(t3);
  if (!props) {
    throw new Error("CollaborationSidebarPropsContext not provided");
  }
  if (fasProps) {
    let t4;
    if ($[4] !== fasProps || $[5] !== isLoadingFAS || $[6] !== props) {
      t4 = Object.assign({}, props, fasProps, {
        isLoadingFAS
      });
      $[4] = fasProps;
      $[5] = isLoadingFAS;
      $[6] = props;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  let t4;
  if ($[8] !== isLoadingFAS || $[9] !== props) {
    t4 = Object.assign({}, props, {
      isLoadingFAS
    });
    $[8] = isLoadingFAS;
    $[9] = props;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}